export const codeSnippetKinds = ['oneline', 'multiline', 'inline'];
export default { codeSnippetKinds };
